<template>
  <div class="flex flex-col gap-4">
    <div>{{ t('menu-availability.stock.current.title') }}</div>
    <div class="flex justify-between items-center bg-n-600 p-4 rounded-lg">
      <div class="flex flex-1 flex-col gap-2">
        <div>{{ t('menu-availability.stock.current.units-label') }}</div>
        <div class="flex flex-1 gap-4 items-center">
          <template v-if="!editStock">
            <div class="font-heading text-[1.75rem] leading-7">{{ modelValue }}</div>
            <div class="text-xs text-n-0 p-1.5 rounded" :class="stockStatus.class">
              {{ stockStatus.text }}
            </div>
          </template>

          <div v-else class="flex flex-1 gap-4 items-center justify-between">
            <l-input class="flex-1" v-model="inputStock" type="number" :min="0" :max="maxValue" />
            <div class="flex gap-2">
              <l-button
                type="text"
                size="small"
                icon="close"
                color="white"
                class="!bg-r-350 shadow-[0_3px_6px_0_#00000033]"
                @click="editStock = false"
              ></l-button>
              <l-button
                type="text"
                size="small"
                icon="check"
                color="white"
                class="!bg-g-550 shadow-[0_3px_6px_0_#00000033]"
                @click="acceptStock"
              ></l-button>
            </div>
          </div>
        </div>
      </div>
      <l-button
        v-if="!editStock"
        type="text"
        size="small"
        icon="edit"
        color="white"
        class="bg-n-600 shadow-[0_3px_6px_0_#00000033]"
        @click="startEditStock"
      ></l-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LButton, LInput } from '@last/core-ui/paprika'

const { t } = useI18n()

const props = defineProps<{
  modelValue: number
  lowStockThreshold: number | undefined
  maxValue: number
}>()

const emit = defineEmits<{
  'update:modelValue': [value: number]
}>()

const editStock = ref(false)
const inputStock = ref(props.modelValue)

const stockStatus = computed(() => {
  const stock = props.modelValue
  const threshold = props.lowStockThreshold
  const hasThreshold = typeof threshold === 'number'

  if (stock === 0) {
    return {
      text: t('menu-availability.stock.status.out-of-stock'),
      class: 'bg-r-350'
    }
  }
  if (hasThreshold && stock > 0 && stock < threshold) {
    return {
      text: t('menu-availability.stock.status.low-stock'),
      class: 'bg-y-500'
    }
  }
  return {
    text: t('menu-availability.stock.status.in-stock'),
    class: 'bg-g-550'
  }
})

/**
 * Resets input value to current stock and enters edit mode.
 */
function startEditStock() {
  inputStock.value = props.modelValue
  editStock.value = true
}

/**
 * Emits the updated stock value to the parent and exits edit mode.
 */
function acceptStock() {
  emit('update:modelValue', inputStock.value)
  editStock.value = false
}
</script>
